(function () {
    'use strict';

    angular
        .module('app')
        .controller('registrationController',
        ['$routeParams', 'accountsService', 'registerService', '_', registrationController]);


    function registrationController($routeParams, accountsService, registerService, _) {
        /* jshint validthis:true */
        var vm = this;
        vm.registrationId = $routeParams.id;

        vm.registration = {};
        
        vm.success = false;
        vm.getRegistration = getRegistration;
        vm.activateRegistration = activateRegistration;
        vm.dynamicsCompany = {};
        vm.dynamicsPager = {
            totalItems: 0,
            currentPage: 1
        };
        vm.dynamicsPaged = [];
        vm.dynamicsFilterValue = '';
        vm.dynamicsFilterApplied = false;
        vm.dynamicswaiting = false;
        vm.pageDynamicsCompanies = pageDynamicsCompanies;
        vm.getDynamicCompanies = getDynamicCompanies;
        vm.setDynamicsCompany = setDynamicsCompany;

        activate();


        function activate() {

            vm.model = accountsService.getAuthenticatedAccount()
                .then(function (response) {
                    vm.model.isAdmin = (response.accountType === AccountType.Admin ||
                        response.accountType === AccountType.SuperAdmin);
                    vm.model.isCompanyAdmin = response.accountType === AccountType.Company;
                    vm.model.isSuperAdmin = (response.accountType === AccountType.SuperAdmin);
                    vm.model.authenticatedAccountId = response.accountId;
                });

            vm.getRegistration();

        }

        function getRegistration() {
            registerService.getRegistration(vm.registrationId)
                .then(function (response) {
                    processRegistration(response);

                    getDynamicCompanies(response.companyName);
                });

        }

        function getDynamicCompanies(companyName) {

            if (companyName) {
                vm.dynamicsFilterApplied = true;
            }
            
            vm.dynamicsPaged = [];
            vm.dynamicsFilterValue = companyName;
            vm.dynamicswaiting = true;

            registerService.dynamicsLookup(companyName)
                .then(function (dynamicsResponse) {
                    vm.dynamicCompanies = dynamicsResponse;

                    if (vm.company !== null && vm.company.dynamicsId !== null) {
                        // see if we can find the Dynamics company
                        var company = _.findWhere(vm.dynamicCompanies, { id: vm.company.dynamicsId });

                        if (_.isUndefined(company)) {
                            vm.dynamicsCompany = null;
                        } else {
                            vm.dynamicsCompany = company;
                        }
                    }

                    vm.dynamicsPager.totalItems = vm.dynamicCompanies.length;
                    vm.dynamicswaiting = false;
                    pageDynamicsCompanies();
                });
        }

        function setDynamicsCompany(dynamics) {

            vm.company.name = dynamics.name;
            vm.company.dynamicsId = dynamics.id;
            vm.productAccount.dynamicsId = dynamics.id;

            var company = _.findWhere(vm.dynamicCompanies, { id: dynamics.id });

            if (_.isUndefined(company)) {
                vm.dynamicsCompany = null;
            } else {
                vm.dynamicsCompany = company;
            }
        }

        function pageDynamicsCompanies() {
            vm.dynamicsPaged = [];
            var startPage = ((vm.dynamicsPager.currentPage - 1) * 10);
            var endPage = (vm.dynamicsPager.currentPage * 10);
            
            // build the page
            for (var i = startPage; i < endPage; i++) {

                if (i > vm.dynamicCompanies.length - 1) break;

                // add the item
                vm.dynamicsPaged.push(vm.dynamicCompanies[i]);
            }
            
        }



        function processRegistration(registration) {

            vm.productAccount = {
                id: registration.id,
                firstName: registration.firstName,
                lastName: registration.lastName,
                contactNumber: registration.phoneNumber,
                email: registration.email,
                companyName: registration.companyName,
                address1: registration.address1,
                address2: registration.address2,
                address3: registration.address3,
                postCode: registration.postCode,
                website: registration.website,
                isCrmIntegrated: registration.isCrmIntegrated,
                crmName: registration.crmName,
                sendEmail: false,
                activate: true,
                products: {
                    gatorLeads: {
                        domain: registration.website,
                        registerUpsell: {
                            trackingQueue: false
                        }
                    }
                }
            };

            vm.company = registration.company;

        }

        function activateRegistration() {

            vm.submitted = true;
            if (!vm.registerAccountForm.$valid) {

                vm.model.working = false;

                vm.model.error = "Please check all fields are filled in correctly.";
                vm.model.complete = true;
                vm.model.success = false;

                return;
            }

        



            registerService.activateRegistration(vm.productAccount, vm.registrationId)
                .then(function (response) {
                    vm.response = response;
                    vm.model.complete = true;
                    vm.model.success = true;
                },
                function (response) {
                    vm.response = response;
                    vm.model.complete = true;
                    vm.model.success = false;
                });
        }


    }
})();
